// removed by extract-text-webpack-plugin
module.exports = {"form_wrapper":"_3rdMR","form_name":"_2EWpI","form_select":"IByPh","form_select_dropdown":"_2sL3n","form_input":"kAO-g","form_btn_wrapper":"lS_Ky","form_collapse":"_1CS75","button":"I_fJH","btn_primary":"_3tkfd I_fJH _3tkfd I_fJH","btn_secondary":"_2Kzz0 I_fJH","btn_warning":"_1FTNK _2Kzz0 I_fJH _1FTNK _2Kzz0 I_fJH","root":"_2pY6f","input_wrapper":"_2xxWS _3rdMR","input_name":"_22jRL _1I1NP","text_input":"_1NPCT kAO-g","button_wrapper":"KNKvr lS_Ky"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/groups/NewGroup.css
// module id = 393
// module chunks = 0